import React from 'react';
import './BengCalList.scss';

const months = [
  'Boishakh (Mesha)', 'Joishtho (Vrishabha)', 'Asharh (Mithuna)', 'Srabon (Karka)', 'Bhadro (Simha)',
  'Ashshin (Kanya)', 'Kartik (Tula)', 'Ogrohaeon (Vrischika)', 'Poush (Dhanu)', 'Magh (Makara)',
  'Falgun (Kumbha)', 'Choitro (Meena)'
];

const nakshatras = [
  'Ashwini', 'Bharani', 'Krittika', 'Rohini', 'Mrigashira', 'Ardra', 'Punarvasu', 'Pushya', 'Ashlesha',
  'Magha', 'Purva Phalguni', 'Uttara Phalguni', 'Hasta', 'Chitra', 'Swati', 'Vishakha', 'Anuradha',
  'Jyeshtha', 'Mula', 'Purva Ashadha', 'Uttara Ashadha', 'Shravana', 'Dhanishtha', 'Shatabhisha',
  'Purva Bhadrapada', 'Uttara Bhadrapada', 'Revati'
];

const yogas = [
  'Vishkambha', 'Priti', 'Ayushmana', 'Saubhagya', 'Shobhana', 'Atiganda', 'Sukarma', 'Dhriti', 'Shula',
  'Ganda', 'Vriddhi', 'Dhruva', 'Vyaghata', 'Harshana', 'Vajra', 'Siddhi', 'Vyatipata', 'Variyana',
  'Parigha', 'Shiva', 'Siddha', 'Sadhya', 'Shubha', 'Shukla', 'Brahma', 'Indra', 'Vaidhriti'
];

const karanas = [
  'Kinstughna', 'Bava', 'Balava', 'Kaulava', 'Taitila', 'Garaja', 'Vanija', 'Vishti',
  'Shakuni', 'Chatushpada', 'Nagava'
];

const tithis = [
  'Shukla Pratipada', 'Shukla Dwitiya', 'Shukla Tritiya', 'Shukla Chaturthi', 'Shukla Panchami',
  'Shukla Shashthi', 'Shukla Saptami', 'Shukla Ashtami', 'Shukla Navami', 'Shukla Dashami',
  'Shukla Ekadashi', 'Shukla Dwadashi', 'Shukla Trayodashi', 'Shukla Chaturdashi', 'Shukla Purnima',
  'Krishna Pratipada', 'Krishna Dwitiya', 'Krishna Tritiya', 'Krishna Chaturthi', 'Krishna Panchami',
  'Krishna Shashthi', 'Krishna Saptami', 'Krishna Ashtami', 'Krishna Navami', 'Krishna Dashami',
  'Krishna Ekadashi', 'Krishna Dwadashi', 'Krishna Trayodashi', 'Krishna Chaturdashi', 'Krishna Amavasya'
];

const rashis = [
  'Mesha', 'Vrishabha', 'Mithuna', 'Karka', 'Simha', 'Kanya',
  'Tula', 'Vrishchika', 'Dhanu', 'Makara', 'Kumbha', 'Meena'
];

const BengCalList = () => {
  return (
    <div className="bengali-calendeer">
      <h1>2025 Bengali Calendar</h1>

      <CalendarSection title="Bengali Month List" items={months} />
      <CalendarSection title="Bengali Nakshatra List" items={nakshatras} />
      <CalendarSection title="Bengali Yoga Names" items={yogas} />
      <CalendarSection title="Bengali Karana Names" items={karanas} />
      <CalendarSection title="Bengali Tithi Names" items={tithis} />
      <CalendarSection title="Bengali Rashi Names" items={rashis} />
    </div>
  );
};

const CalendarSection = ({ title, items }) => (
  <div className="calendar-section">
    <h2>{title}</h2>
    <ul>
      {items.map((item, i) => (
        <li key={i}>{item}</li>
      ))}
    </ul>
  </div>
);

export default BengCalList;
